// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote___nCTf","modalFooterButton":"ModalNotes_modalFooterButton__3aZc1"};